module.exports = __webpack_public_path__ + "static/media/chen_yu_chester_hsieh.95412e81.png";